export default {"src":"/_next/static/media/garansi-logo.90a1385b.svg","height":56,"width":64,"blurWidth":0,"blurHeight":0};